import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ns-out-layout',
  templateUrl: './out-layout.component.html',
  styleUrls: ['./out-layout.component.scss']
})
export class OutLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
